import * as Yup from 'yup';
import PropTypes from 'prop-types';

export const useFeaturedFilter = ({ setFilters }) => {
  const formSchema = Yup.object().shape({
    featured: Yup.object().shape({
      label: Yup.string().required(),
      value: Yup.string().required(),
    }),
  });

  const onSubmit = ({ featured }) => {
    setFilters(
      { featured: featured.value || 'any' },
      {
        removeFilters: featured.value === 'any' ? ['featured'] : [],
      },
    );
  };

  return {
    formSchema,
    onSubmit,
  };
};

useFeaturedFilter.propTypes = {
  setFilters: PropTypes.func.isRequired,
};
